import React, { Component } from "react";
import classNames from "classnames";
import "./style.scss";
import { appendQuery } from "../../utils/urlHelper";

export default class Image extends Component {
  componentDidMount() {
    if (this.props && this.refs.image) {
      window.addEventListener("resize", this.setImage.bind(this));
      this.setImage();
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    this.setImage();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.setImage, false);
  }
  setImage() {
    if (this.refs.image && this.refs.parent) {
      const parentWidth = this.refs.parent.offsetWidth;
      const imageWidth =
        Math.min.apply(
          null,
          [
            1200 - parentWidth,
            992 - parentWidth,
            768 - parentWidth,
            500 - parentWidth,
            300 - parentWidth
          ].filter(e => e > 0)
        ) + parentWidth;
      this.refs.image.src = appendQuery(
        this.props.src,
        {
          devicetype: imageWidth
        },
        ["iar"]
      ).replace("jssmedia", "media");
    }
  }

  handleLoad() {
    this.props.handleLoad && this.props.handleLoad();
  }
 
  render() {
    const imageClassNames = classNames(
      "image",
      this.props.className ? this.props.className : ""
    );
    const ids = this.props.id ? this.props.id : "";
    const captionClassNames = "caption";
    if (this.props && this.props.src) {
      return (
        <div ref="parent" className={imageClassNames} id={ids}>
          <img
            ref="image"
            srcSet={this.props.src}
            alt={this.props.alt}
            title={this.props.alt}
            onLoad={this.handleLoad.bind(this)}
            className="lazyload"
          />
          {this.props.caption && (
            <figcaption className={captionClassNames}>
              {this.props.caption}
            </figcaption>
          )}
        </div>
      );
    } else {
      return null;
    }
  }
}
